import React, { Component } from 'react'
import './event-students.scss'
import SchoolUserApi from '../../../apis/student'
import Loading from '../../common/loading/loading'
import FilterComponent from '../filter/filter'
import PaginationComponent from '../../common/cw-pagination/cw-pagination-v2'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faDownload } from '@fortawesome/free-solid-svg-icons'
import { faHome, faSpinner } from '@fortawesome/free-solid-svg-icons'
import {
  faArrowDown,
  faArrowUp,
  faCheckCircle,
  faTimesCircle
} from '@fortawesome/free-solid-svg-icons'
let { Parser } = require('json2csv');




class EventStudents extends Component {
  state = {
    eventStudents: [],
    meta: { totalPages: 1, page: 1 },
    isLoading: false,
    selectedPage: 1
  }
  limit = 10;
  currentPage = 1;
  startIndex = 1;
  filter = {}
  constructor (props) {
    super(props)
  }

  componentDidMount () {
    const { selectedClass } = this.props
    const payload = {}
    if (selectedClass && selectedClass !== 'All') {
      payload.class = selectedClass
      this.setState({
        selectedClass: payload.class
      })
    }
    this.getEventStudentList(payload)
  }

  setSelectedClass = (payload = {}) => {
    this.setState({
      selectedClass: payload.class
    }, _ => {
      delete this.filter.class
      delete this.filter.page
      if(payload.class) this.filter.class = payload.class
      this.getEventStudentList(this.filter)
    })
  }

  getEventStudentList = (payload = {}) => {
    const {selectedClass} = this.state
    const {reportScreen, event} = this.props
    payload.eventId = event._id
    this.setState({
      isLoading: true
    })
    if(reportScreen === "improvement") payload.finishlineStatus = "COMPLETED"
    if(selectedClass) payload.class = selectedClass
    if (!payload.page) payload.page = 1
    if (!payload.limit) payload.limit = this.limit
    this.currentPage = payload.page


    
    if (this.currentPage === 1) this.startIndex = 1

      SchoolUserApi.getEventStudentList(payload)
        .then(result => {
          this.setState({
            eventStudents: result.response,
            meta: result.meta,
            isLoading: false,
          })
          
        })
        .catch(err => {
          console.log(err)
        })
  }

  onFilterGo = (payload ={}) => {
    this.filter = payload    
    this.getEventStudentList(this.filter)
  }

  onPageSelected = (selectedPage, startIndex) => {
    this.startIndex = startIndex
    this.filter.page = selectedPage
    this.setState({selectedPage})
    this.getEventStudentList(this.filter)
  }

  renderPercentageChange(baseline, finish) {
    let initialValue = baseline && baseline.markScored ? (baseline.markScored/baseline.totalMark) * 100 : 0
    let finalValue = finish && finish.markScored ? (finish.markScored/finish.totalMark) * 100 : 0
    let calcValue = Math.round(finalValue) - Math.round(initialValue);
    // if(finalValue !== 0) {
    //     if(initialValue !== 0) {
    //         percent = (finalValue - initialValue) / initialValue * 100;
    //     } else {
    //         percent = finalValue * 100;
    //     }
    // } else {
    //     percent = - initialValue * 100;
    // }       
    return (
      <div className={`${calcValue >= 0 ? 'percentage-up': 'percentage-down'}`}>
        {
          calcValue >= 0 ? (
            <FontAwesomeIcon icon={faArrowUp} />
          ) : (
            <FontAwesomeIcon icon={faArrowDown} />
          )
        }
        {"  " + Math.abs(Math.round(calcValue))}%
        
      </div>
    )
}


onClickExportSelectedClassStudents(eventStudents) {

  //console.log(this.state.eventStudents)
  console.log(eventStudents)

  if (this.state.exporting) return

    
 if(eventStudents.length) this.setState({ exporting: true })

  let selectedClassStudents = eventStudents



  if (selectedClassStudents) {

let csvBuild = []
for (let i = 0; i < selectedClassStudents.length; i++) {
  let item = selectedClassStudents[i]

  let obj = {
  }
  if (item["schoolId"]) {


    if (item["name"]) {
      obj['Student Name'] = item["name"]
    }

    if (item["gender"]) {
      obj['Gender'] = item["gender"]
    }

    // if (item["alternateBoard"]) {
    //   obj['Board'] = item["alternateBoard"]
    // }

    if (item["class"]) {
      obj['CLASS'] = item["class"]
    }

    // if (item["countryCode"]) {
    //   obj['COUNTRY CODE'] = item["countryCode"]
    // }

    if (item["mobileNumber"]) {
      obj['MOBILE NUMBER'] = item["mobileNumber"]
    }

    if (item["email"]) {
      obj['EMAIL'] = item["email"]
    }

    // if (item["schoolId"]) {
    //   obj['SCHOOL CODE'] = item["schoolId"]
    // }

    //   if (item["schoolName"]) {
    //       obj['SCHOOL NAME'] = item["schoolName"]
    //   }

      if (item["isSubscribed"]) {
        obj['PAYMENT STATUS'] = "Paid"
        
      } else {
        obj['PAYMENT STATUS'] = "Not Paid"
      }

      if(item["finalAssessment"]["status"] === "COMPLETED") {
        obj["TEST STATUS"] = 'TAKEN'
      }else if(item["finalAssessment"]["status"] === "IN_PROGRESS"){
        obj["TEST STATUS"] = 'NOT TAKEN'
      }else {
        obj["TEST STATUS"] = 'NA'
      }
  }

  csvBuild.push(obj)
}
let json2csvParser = new Parser();
let csv = json2csvParser.parse(csvBuild);

// console.log(csv);

let hiddenElement = document.createElement('a');
hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
hiddenElement.target = '_blank';
hiddenElement.download = 'student_report_' + (new Date).toISOString() + '.csv';
hiddenElement.click();
}
this.setState({ exporting: false })

}


datePipe(givenDate, isTime = true) {
  if (!givenDate) return "-"
  givenDate = new Date(givenDate).toString()
  const [day, month, date, year, time] = givenDate.split(' ')
  return `${date} ${month}, ${year} ${isTime ? time.substr(0, 5) : ""}`

}



  render () {
    const { eventStudents } = this.state
    const { reportScreen, eventProgress } = this.props
    return (
      <>
        {reportScreen === "students" && 
          <FilterComponent onGo={this.onFilterGo} delegate={this} eventProgress={eventProgress} />
        }
         {eventStudents.length > 0  && (
            <>
              <div className=''>
              <strong className="report-buttons1">
                        <button className='cw-button-primary' onClick={() => { this.onClickExportSelectedClassStudents(eventStudents) }}>
                            {
                                !this.state.exporting ? <span className='download-icon'> <FontAwesomeIcon icon={faDownload} /><span className='ml-2'>Export to Excel</span></span>  :
                                    <span>  <FontAwesomeIcon icon={faSpinner} spin /><span className='ml-2'>Exporting</span></span>
                            }
                        </button>
                    </strong>
              </div>
            </>
          )}
        <div id='table-scoll' className='table-responsive mt-1'>
          {this.state.isLoading && <Loading style={{top: '100px'}}></Loading>}
          <table className='table cw-table mb-0 align-items-center student-list'>
            <thead>
              <tr>
                <th className='text-center th-left-radius'>Sr no</th>
                <th className='text-center'>Student</th>
                <th className='text-center'>Class</th>
                {/* <th className='text-center'>Baseline Assessment</th> */}
                <th className='text-center'>Mobile Number</th>
                <th className='text-center'>Email</th>
                {/* {reportScreen === "students" && 
                  <th className='text-center'>Qualifying Course</th>
                } */}
                {eventProgress === "resultAnnounced" && 
                  <th className='text-center'>Finishline Assessment</th>
                }
                {reportScreen === 'improvement' && <th className='text-center th-right-radius'>Improvement</th>}
              </tr>
            </thead>
            <tbody className='bg-white'>
              {eventStudents.length > 0 &&
                eventStudents.map((student, index) => (
                  <tr key={index} className='mt-4'>
                    <td className="text-center">{(index + 1) + ((this.currentPage - 1) * 10)}.</td>
                    <td className="text-center"><div className='name-text'>{student?.name}</div>{student?.isSubscribed && <div><span className='premium-text'>{"Premium"}</span></div>}</td>
                    <td className="text-center">{student?.class}</td>
                    <td className="text-center">{`${student?.countryCode} ${student?.mobileNumber}`}</td>
                    <td className="text-center">{student?.email}</td>

                    {/* {reportScreen === "students" && 
                      <td className="text-center">
                        <span className='check-circle'>
                          {student?.eventBaseline && student?.eventBaseline?.status === 'COMPLETED' ? (
                            <FontAwesomeIcon icon={faCheckCircle} color='#6ae5d3' />
                          ) : (
                            <FontAwesomeIcon icon={faTimesCircle} color='#ed4040' />
                          )}
                        </span>

                      </td>
                    } */}
                    {eventProgress === "resultAnnounced" && reportScreen === "students" && 
                      <td className="text-center">
                        <span className='check-circle'>
                          {
                            (student?.qualified || student?.eventWorkflow?.percentage >= 100) ? (
                              <FontAwesomeIcon icon={faCheckCircle} color='#6ae5d3' />
                            ) : (
                              <FontAwesomeIcon icon={faTimesCircle} color='#ed4040' />
                            )
                          }
                        </span>
                      </td>
                    }
                    {/* {reportScreen === "students" && 
                      <td className="text-center">
                        <span className='check-circle'>
                          {student?.finalAssessment &&
                          student?.finalAssessment?.status === 'COMPLETED' ? (
                            <FontAwesomeIcon icon={faCheckCircle} color='#6ae5d3' />
                          ) : (
                            <FontAwesomeIcon icon={faTimesCircle} color='#ed4040' />
                          )}
                        </span>

                      </td>
                    } */}
                    {reportScreen === "improvement" && 
                      <td className="text-center">
                        {student?.eventBaseline?.markScored
                        ? Math.round((student.eventBaseline.markScored /
                            student.eventBaseline.totalMark) *
                          100) + "%"
                        : "--"}
                      </td>
                    }
                    {reportScreen === "improvement" && 
                      <td className="text-center">
                        {student?.finalAssessment?.markScored
                          ? Math.round((student.finalAssessment.markScored /
                            student.finalAssessment.totalMark) *
                          100) + "%"
                        : "--"}
                      </td>
                    }
                    {reportScreen === 'improvement' && 
                      <td className="text-center">
                        {this.renderPercentageChange(student?.eventBaseline, student?.finalAssessment)}
                      </td>
                    }
                  </tr>
                ))}
              {!eventStudents.length && (
                <tr className='mt-4'>
                  <td colSpan='8' className='text-center'>
                    {' '}
                    No Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div className='card-footer'>
              {
                 !this.state.isLoading && this.state.meta.totalPages ?
                      <PaginationComponent startIndex={this.startIndex} selectedPage={this.currentPage} totalPages={this.state.meta.totalPages} onPageSelected={this.onPageSelected.bind(this)} /> : ''
              }
          </div>
        </div>
      </>
    )
  }
}

export default EventStudents
